<template>
  <v-container>
    <v-row class="text-center">
      <v-col>
        <h2>Kies een dashboard</h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card class="mx-auto" max-width="400" :to="{name:'projectdashboard'}" title="Project dashboard">
          <v-card-title>Project dashboard</v-card-title>
          <v-card-subtitle>Project dashboard is leuk</v-card-subtitle>
          <v-img
            class="white--text align-end"
            height="200px"
            src="@/assets/icon-dashboard-project.png"
          />
        </v-card>
      </v-col>
      <v-col>
        <v-card class="mx-auto" max-width="400" :to="{name:'appmeldingdashboard'}" title="Afdeling dashboard">
          <v-card-title>App melding dashboard</v-card-title>
          <v-card-subtitle>App meldingen van vorige week</v-card-subtitle>
          <v-img
            class="white--text align-end"
            height="200px"
            src="@/assets/icon-dashboard-appmeldingen.png"
          />
        </v-card>
      </v-col>
      <v-col>
        <v-card class="mx-auto" max-width="400" :to="{name:'home'}" title="Ander dashboard">
          <v-card-title>Afdeling dashboard</v-card-title>
          <v-card-subtitle>Maar afdeling dashboards zijn ook leuk</v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
export default {
  name: "HelloWorld",

  data: () => ({})
};
</script>
